import { Injectable } from '@angular/core';
import { UploadService } from './app/_services/upload.service';
import { ConstantHelper } from './app/_helpers/constant.helper';
import { BehaviorSubject } from 'rxjs';
import { SweetAlertHelper } from './app/_helpers/sweet.alert.helper';

@Injectable({
  providedIn: 'root'
})
export class ScreenRecorderService {
  private recorder: MediaRecorder | undefined;
  private combinedStream: MediaStream | undefined;
  private videoUrlSubject = new BehaviorSubject<string | undefined>(undefined);
  public videoUrl$ = this.videoUrlSubject.asObservable();
  
  private showLoaderSubject = new BehaviorSubject<boolean>(false);
  public showLoader$ = this.showLoaderSubject.asObservable();
  
  companySlug = ConstantHelper.COMPANY_SLUG;
  selectedPhysiciansIds: any = [];
  completeBlob: any;
  fileName: any;
  recordedFile: any;
  showLoader = false;

  constructor(
    private UploadService: UploadService,
    public sweetAlertHelper: SweetAlertHelper,
  ) {} 


  async startRecording(patientName: string, physicianName: string): Promise<void> {
    try {
      const displayStream = await this.getDisplayStream();
      const micStream = await this.getMicrophoneStream();

      this.combinedStream = new MediaStream([
        ...displayStream.getTracks(),
        ...micStream.getAudioTracks()
      ]);
      // Only stop recording if user manually stops sharing screen
      displayStream.getTracks().forEach(track => {
        track.onended = () => {
          // Only stop if the user manually stopped sharing
          if (this.recorder && this.recorder.state === "recording") {
            this.stopRecording();
          }
        };
      });

      this.recorder = new MediaRecorder(this.combinedStream, {
        mimeType: 'video/webm; codecs=vp9,opus',
        videoBitsPerSecond: 1000000,
        audioBitsPerSecond: 64000
      });

      const chunks: Blob[] = [];
      this.recorder.ondataavailable = (e) => chunks.push(e.data);
      this.recorder.onstop = () => {
        this.handleRecordingStop(chunks, patientName, physicianName);
        this.showNotification("Recording Stopped", "Your screen recording has been stopped.");
      };

      this.recorder.start();

      // Auto-stop after 2 minutes (120 seconds)
      // setTimeout(() => {
      //   if (this.recorder && this.recorder.state === "recording") {
      //     this.recorder.stop();
      //   }
      // }, 120000);
    } catch (err) {
      console.error('Error starting recording: ', err);
    }
  }

  private showNotification(title: string, body: string): void {
    if (Notification.permission === "granted") {
      new Notification(title, { body });
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then(permission => {
        if (permission === "granted") {
          new Notification(title, { body });
        }
      });
    }
  }

  stopRecording(): void {
    if (this.recorder) {
      this.recorder.stop();
    }
    this.cleanupStreams();
  }

  private async getDisplayStream(): Promise<MediaStream> {
    const displayMediaOptions = {
      video: {
        width: { ideal: 1280 },
        height: { ideal: 720 },
        frameRate: { ideal: 30, max: 30 }
      },
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        sampleRate: 44100
      }
    };
    return await navigator.mediaDevices.getDisplayMedia(displayMediaOptions);
  }

  private async getMicrophoneStream(): Promise<MediaStream> {
    return await navigator.mediaDevices.getUserMedia({ audio: true });
  }

  private handleRecordingStop(chunks: Blob[], patientName: string, physicianName: string): void {
    if (chunks.length === 0) return;
  
    this.completeBlob = new Blob(chunks, { type: 'video/webm' });
    this.fileName = `${this.generateFileName(patientName, physicianName)}.mp4`;
    this.recordedFile = new File([this.completeBlob], this.fileName, { type: 'video/webm' });
    // this.uploadRecordedFile(recordedFile);
    // this.videoUrl = URL.createObjectURL(completeBlob);
    const videoUrl = URL.createObjectURL(this.completeBlob);

    this.videoUrlSubject.next(videoUrl); 
    // this.downloadVideo(completeBlob, patientName, physicianName);
    this.cleanupStreams();
  }

  private downloadVideo(blob: Blob, patientName: string, physicianName: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${this.generateFileName(patientName, physicianName)}.mp4`;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 100);
  }

  private generateFileName(patientName: string, physicianName: string): string {
    const formattedPatientName = patientName.replace(/, /g, '-');
    const formattedPhysicianName = physicianName.replace(/, /g, '-');
    const now = new Date();
    const formattedDate = `${this.pad(now.getMonth() + 1)}${this.pad(now.getDate())}${now.getFullYear()}${this.pad(now.getHours())}${this.pad(now.getMinutes())}${this.pad(now.getSeconds())}`;
    return `${formattedPatientName}_${formattedPhysicianName}_${formattedDate}`;
  }

  private pad(number: number): string {
    return number < 10 ? `0${number}` : `${number}`;
  }

  private cleanupStreams(): void {
    if (this.combinedStream) {
      this.combinedStream.getTracks().forEach(track => track.stop());
      this.combinedStream = undefined;
    }
  }

  uploadVideoExport(){
    this.uploadRecordedFile(this.recordedFile);
  }

  private uploadRecordedFile(file: File): void {
    this.showLoader = true;
    this.showLoaderSubject.next(true);
    this.UploadService.uploadOtherDocument(
    localStorage.getItem("loggedInUserId"),
    sessionStorage.getItem("patientId"),
    sessionStorage.getItem("formId"),
    this.companySlug,
    localStorage.getItem("loggedInUserComapnyId"),
    file,
    18,
    file.name,
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    localStorage.getItem("loggedInUserId"),
    '',
    ''
    ).subscribe(
      (data: any) => {
        this.showLoader = false;
        this.showLoaderSubject.next(false);
        if(data.commandResult.success == 1){
          const alertStatus = this.sweetAlertHelper.alertPopUp('Video Uploaded Successfully')
          if(alertStatus){
            window.location.reload();
            return false
          }
        }
        console.log("Video uploaded successfully:", data);
      },
      (error) => {
        this.showLoader = false;
        this.showLoaderSubject.next(false);
        console.error("Error uploading video:", error);
      }
    );
  }
}
